import Swiper from 'swiper';

export default class SliderFeaturedItems {
	constructor(sliderElement) {

        this.breakpoint = window.matchMedia('(max-width:820px)');

        const options = {
            direction: 'horizontal',
            slidesPerView: 1.1,
            lazy: true,
            speed: 1000,
            keyboard: true,
            spaceBetween: 16,
        };

        this.swiper = new Swiper(sliderElement, options);

        if ( this.breakpoint.matches === false ) {

            this.swiper.destroy( true, true );
            return;
        }
	}
}
